<template>
  <section class="selector">
    <div
      v-for="option of options"
      @click="select(option)"
      :key="option.value"
      class="selector-option"
      :class="{ 'active' : option.value === value }"
    >
      {{ option.text }}
    </div>
  </section>
</template>

<script>
export default {
  name: 'Selector',
  props: ['value', 'options'],
  methods: {
    select (option) {
      this.$emit('input', option.value)
      this.$emit('change', option.value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.selector {
  height: 28px;
  display: flex;
  background-color: $primary-color;
  color: $secondary-color;
  font-size: 14px;
  border-radius: 7px;
  padding: 5px;
}

.selector-option {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  border-radius: 4px;
  transition: background-color 0.5s;
  cursor: pointer;
  &.active {
    background-color: #fff;
    color: #595959 !important;
    padding: 7px;
    box-shadow: 0 0 3px 0 rgba(0,0,0,0.6);
  }
}
</style>
